/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetOAuthToken429Response } from '../models';
// @ts-ignore
import type { GetOAuthTokenRequest } from '../models';
// @ts-ignore
import type { OAuthScopesResponse } from '../models';
// @ts-ignore
import type { RefreshTokenRequest } from '../models';
// @ts-ignore
import type { RevokeAllTokensForPartner200Response } from '../models';
// @ts-ignore
import type { RevokeTokenRequest } from '../models';
// @ts-ignore
import type { TokenResponse } from '../models';
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all available OAuth scopes with descriptions
         * @summary Get available OAuth scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableOAuthScopes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/oauth/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange client credentials for an access token
         * @summary OAuth 2.0 token endpoint
         * @param {GetOAuthTokenRequest} getOAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthToken: async (getOAuthTokenRequest: GetOAuthTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOAuthTokenRequest' is not null or undefined
            assertParamExists('getOAuthToken', 'getOAuthTokenRequest', getOAuthTokenRequest)
            const localVarPath = `/api/v1/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOAuthTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange a refresh token for a new access token
         * @summary OAuth 2.0 refresh token endpoint
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOAuthToken: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshOAuthToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/api/v1/oauth/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke all refresh tokens for an API key (admin only)
         * @summary Revoke all tokens for an API key
         * @param {string} apiKeyId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllTokensForApiKey: async (apiKeyId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('revokeAllTokensForApiKey', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/oauth/token/revoke/apikey/{apiKeyId}`
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke all refresh tokens for a partner (admin only)
         * @summary Revoke all tokens for a partner
         * @param {string} partnerId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllTokensForPartner: async (partnerId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('revokeAllTokensForPartner', 'partnerId', partnerId)
            const localVarPath = `/api/v1/oauth/token/revoke/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a refresh token
         * @summary OAuth 2.0 token revocation endpoint
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOAuthToken: async (revokeTokenRequest: RevokeTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokeTokenRequest' is not null or undefined
            assertParamExists('revokeOAuthToken', 'revokeTokenRequest', revokeTokenRequest)
            const localVarPath = `/api/v1/oauth/token/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all available OAuth scopes with descriptions
         * @summary Get available OAuth scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableOAuthScopes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthScopesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableOAuthScopes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getAvailableOAuthScopes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange client credentials for an access token
         * @summary OAuth 2.0 token endpoint
         * @param {GetOAuthTokenRequest} getOAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOAuthToken(getOAuthTokenRequest: GetOAuthTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOAuthToken(getOAuthTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getOAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange a refresh token for a new access token
         * @summary OAuth 2.0 refresh token endpoint
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshOAuthToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshOAuthToken(refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshOAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke all refresh tokens for an API key (admin only)
         * @summary Revoke all tokens for an API key
         * @param {string} apiKeyId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAllTokensForApiKey(apiKeyId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeAllTokensForPartner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAllTokensForApiKey(apiKeyId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.revokeAllTokensForApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke all refresh tokens for a partner (admin only)
         * @summary Revoke all tokens for a partner
         * @param {string} partnerId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAllTokensForPartner(partnerId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeAllTokensForPartner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAllTokensForPartner(partnerId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.revokeAllTokensForPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a refresh token
         * @summary OAuth 2.0 token revocation endpoint
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeOAuthToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeOAuthToken(revokeTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.revokeOAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Retrieve all available OAuth scopes with descriptions
         * @summary Get available OAuth scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableOAuthScopes(options?: RawAxiosRequestConfig): AxiosPromise<OAuthScopesResponse> {
            return localVarFp.getAvailableOAuthScopes(options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange client credentials for an access token
         * @summary OAuth 2.0 token endpoint
         * @param {GetOAuthTokenRequest} getOAuthTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthToken(getOAuthTokenRequest: GetOAuthTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.getOAuthToken(getOAuthTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange a refresh token for a new access token
         * @summary OAuth 2.0 refresh token endpoint
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshOAuthToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.refreshOAuthToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke all refresh tokens for an API key (admin only)
         * @summary Revoke all tokens for an API key
         * @param {string} apiKeyId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllTokensForApiKey(apiKeyId: string, reason?: string, options?: RawAxiosRequestConfig): AxiosPromise<RevokeAllTokensForPartner200Response> {
            return localVarFp.revokeAllTokensForApiKey(apiKeyId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke all refresh tokens for a partner (admin only)
         * @summary Revoke all tokens for a partner
         * @param {string} partnerId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllTokensForPartner(partnerId: string, reason?: string, options?: RawAxiosRequestConfig): AxiosPromise<RevokeAllTokensForPartner200Response> {
            return localVarFp.revokeAllTokensForPartner(partnerId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a refresh token
         * @summary OAuth 2.0 token revocation endpoint
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOAuthToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeOAuthToken(revokeTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Retrieve all available OAuth scopes with descriptions
     * @summary Get available OAuth scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getAvailableOAuthScopes(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getAvailableOAuthScopes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange client credentials for an access token
     * @summary OAuth 2.0 token endpoint
     * @param {GetOAuthTokenRequest} getOAuthTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getOAuthToken(getOAuthTokenRequest: GetOAuthTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getOAuthToken(getOAuthTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange a refresh token for a new access token
     * @summary OAuth 2.0 refresh token endpoint
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshOAuthToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshOAuthToken(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke all refresh tokens for an API key (admin only)
     * @summary Revoke all tokens for an API key
     * @param {string} apiKeyId 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public revokeAllTokensForApiKey(apiKeyId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).revokeAllTokensForApiKey(apiKeyId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke all refresh tokens for a partner (admin only)
     * @summary Revoke all tokens for a partner
     * @param {string} partnerId 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public revokeAllTokensForPartner(partnerId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).revokeAllTokensForPartner(partnerId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a refresh token
     * @summary OAuth 2.0 token revocation endpoint
     * @param {RevokeTokenRequest} revokeTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public revokeOAuthToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).revokeOAuthToken(revokeTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

